module.exports = __webpack_public_path__ + "img/p2-27.1e79e4e3.png";